<template>
  <div class="w-full">
    <SuccessButton
      class="mr-6"
      :disabled="!$atividades.permissoes.includes(14)"
      @func="modalCadastroFormasPagamento = true"
    ></SuccessButton>
    <SideBar
      title="Nova Forma de Pagamento"
      @hide="modalCadastroFormasPagamento = false"
      size="small"
      :active="modalCadastroFormasPagamento"
      @success="submitForm()"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              name="nome"
              v-validate="'required'"
              label-placeholder="Forma de pagamento"
              v-model="formaPagamento.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "ModalCadastroFormasPagamento",
  data() {
    return {
      formaPagamento: {},
      modalCadastroFormasPagamento: false,
      error: false
    };
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.cadastrarFormaPagamento();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async cadastrarFormaPagamento() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.$vs.loading();
          try {
            const res = await this.$http.post("formasPagamento", this.formaPagamento);
            let logData = {
              id_colaborador: localStorage.getItem("id"),
              funcao: 'cadastrar',
              setor: 'serviços',
              ip: window.localStorage.getItem("ip"),
              texto: 'Cadastro da forma de pagamento N° ' + res.id}
            await this.$logger(logData)
            this.formaPagamento = await {};
            this.$vs.notify(this.$notify.Success);
            this.modalCadastroFormasPagamento = false;
          } catch (err) {
            const error = this.$httpErrors(err);
            this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
          } finally {
            this.$vs.loading.close();
            await this.$emit("update");
          }
        }
      });
    }
  },
  components: components
};
</script>

<style></style>
